<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div id="user-profile">
      <!-- profile header -->
      <div class="row">
        <div class="col-12">
          <div class="card profile-header mb-2">
            <!-- profile cover photo -->
            <img class="card-img-top" [src]="'assets/images/profile/user-uploads/timeline.jpg'"
              alt="User Profile Image" />
            <!--/ profile cover photo -->

            <div class="position-relative">
              <!-- profile picture -->
              <div class="profile-img-container d-flex align-items-center">
                <div class="profile-img">
                  <img [src]="
                      utils.getAuthorImageByMedia(userData)
                        ? utils.getAuthorImageByMedia(userData)
                        : 'assets/images/logo/logo.svg'
                    " class="img-fluid w-100 h-100" style="object-fit: fill;" />
                </div>
                <!-- profile title -->
                <div class="profile-title ml-3">
                  <h2 class="text-white">
                    {{ userData?.firstName + " " + userData.lastName }}
                  </h2>
                  <p class="text-white">
                    {{ userData.role }}
                  </p>
                </div>
              </div>
            </div>

            <!-- tabs pill -->
            <div class="profile-header-nav">
              <!-- navbar -->
              <nav class="navbar navbar-expand-md navbar-light justify-content-end justify-content-md-between w-100">
                <button class="btn btn-icon navbar-toggler" type="button" data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                  (click)="toggleMenu = !toggleMenu" rippleEffect>
                  <i data-feather="align-justify" class="font-medium-5"></i>
                </button>

                <!-- collapse -->
                <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="toggleMenu">
                  <div class="profile-tabs d-flex justify-content-between flex-wrap mt-1 mt-md-0">
                    <ul class="nav nav-pills mb-0">
                      <li class="nav-item mr-1" (click)="activePill = 'home'">
                        <a class="nav-link font-weight-bold" href="javascript:void(0)"
                          [class.active]="activePill === 'home'">
                          Home
                        </a>
                      </li>

                      <!-- Feeds Services -->
                      <li class="nav-item mr-1" (click)="activePill = 'feed'">
                        <a class="nav-link font-weight-bold" href="javascript:void(0)"
                          [class.active]="activePill === 'feed'">
                          <span class="d-none d-md-block">Feed</span>
                          <i data-feather="rss" class="d-block d-md-none"></i>
                        </a>
                      </li>

                      <!-- User Services -->
                      <li class="nav-item" (click)="activePill = 'userServices'">
                        <a class="nav-link font-weight-bold" href="javascript:void(0)"
                          [class.active]="activePill === 'userServices'">
                          <span class="d-none d-md-block">User Services</span>
                          <i data-feather="rss" class="d-block d-md-none"></i>
                        </a>
                      </li>

                    </ul>

                    <!-- Profile Stats Section -->
                    <div
                      class="d-flex flex-wrap justify-content-center justify-content-md-end text-center text-md-center ">
                      <div class="mx-2">
                        <p class="text-muted card-text">Profile Views</p>
                        <span class="font-weight-bold">{{userStats.profileViews}}</span>
                      </div>
                      <div class="mx-2">
                        <p class="text-muted card-text">Post Views</p>
                        <span class="font-weight-bold">{{userStats.postViews}}</span>
                      </div>
                      <div class="mx-2">
                        <p class="text-muted card-text">Search Appearances</p>
                        <span class="font-weight-bold">{{userStats.searchAppearances}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!--/ collapse -->
              </nav>
              <!--/ navbar -->

              <!-- Additional Profile Stats Section -->

              <!--/ profile stats -->
            </div>
            <!--/ profile-header-nav -->
          </div>
        </div>
      </div>


      <section id="profile-info">
        <div class="row">
          <!-- left profile info section -->
          <div class="col-lg-3 col-12 order-2 order-lg-1" *ngIf="activePill != 'feed'">
            <!-- about -->
            <div class="card">
              <div class="card-body">
                <h5 class="mb-75 text-muted">About</h5>
                <p class="card-text">
                  {{ userData?.bio || "---" }}
                </p>
                <div class="mt-2">
                  <h5 class="mb-75 text-muted">Joined:</h5>
                  <p class="card-text">
                    {{ userData.createdAt | date }}
                  </p>
                </div>
                <div class="mt-2">
                  <h5 class="mb-75 text-muted">Birthdate:</h5>
                  <p class="card-text">
                    {{ userData.birthdate }}
                  </p>
                </div>
                <div class="mt-2">
                  <h5 class="mb-75 text-muted">Email:</h5>
                  <p class="card-text">
                    {{ userData.email }}
                  </p>
                </div>
                <div class="mt-2">
                  <h5 class="mb-50 text-muted">Location:</h5>
                  <p class="card-text mb-0">
                    {{
                    (userData?.country?.name || "Unknown Country") +
                    " - " +
                    (userData?.cityObject?.name || "Unknown City")
                    }}
                  </p>
                </div>
                <div class="mt-2">
                  <h5 class="mb-50 text-muted">Nationality:</h5>
                  <p class="card-text mb-0">
                    {{ userData?.nationality?.name || "Unknown Nationality" }}
                  </p>
                </div>

                <div class="mt-2">
                  <h5 class="mb-50 text-muted">Gender:</h5>
                  <p class="card-text mb-0">
                    {{ userData?.gender || "Not specified" }} <i
                      [ngClass]="userData?.gender.toLowerCase() === 'male' ? 'bi bi-gender-male text-primary' : 'bi bi-gender-female text-danger'"></i>
                  </p>
                </div>

                <div class="mt-2">
                  <h5 class="mb-50 text-muted">Role:</h5>
                  <p class="card-text mb-0 badge badge-light-primary">
                    {{ userData?.role || "Not specified" }}
                  </p>
                </div>

                <div class="mt-2" *ngIf="userData?.totalTeamsCoached">
                  <h5 class="mb-50 text-muted">Total Number of Team Coached:
                    <span class="card-text mb-0 badge badge-light-secondary">
                      {{ userData?.totalTeamsCoached || "Not specified" }}
                    </span>
                  </h5>

                </div>


                <div class="mt-2" *ngIf="userData?.weight">
                  <h5 class="mb-50 text-muted">Weight:</h5>
                  <p class="card-text mb-0">
                    {{ userData?.weight }} <span class="small text-muted">(KG)</span>
                  </p>
                </div>

                <div class="mt-2" *ngIf="userData?.totalRepresented">
                  <h5 class="mb-50 text-muted">Total Represented:
                    <p class="card-text mb-0 badge badge-light-secondary">
                      {{ userData?.totalRepresented }}
                    </p>
                  </h5>

                </div>


                <div class="mt-2">
                  <h5 class="mb-50 text-muted">Verification Status:</h5>
                  <p class="card-text mb-0 badge" [ngClass]="{
     'badge-light-success': userData?.verificationStatus?.toLowerCase() === 'verified',
     'badge-light-danger': userData?.verificationStatus?.toLowerCase() === 'unverified'
   }">
                    {{ userData?.verificationStatus || "Not specified" }}
                  </p>

                </div>
              </div>
            </div>
            <!--/ about -->
          </div>
          <!--/ left profile info section -->
          <!-- center profile info section -->
          <div class="col-lg-6 col-6 order-1 order-lg-2" *ngIf="activePill != 'feed'">
            <!-- If userActivities is empty -->



            <!-- User service section -->
            <ng-container *ngIf="activePill === 'userServices' ">
              <div class="col-md-12 col-lg-12 mb-4" *ngFor="let service of services">
          <div class="card h-100 d-flex flex-column position-relative">
            <div class="image-wrapper">
              <div
                class="position-absolute top-0 end-0 m-2 z-1 dropdown button-badge"
              >
                <div ngbDropdown container="body">
                  <a
                    ngbDropdownToggle
                    href="javascript:void(0);"
                    class="hide-arrow btn btn-icon btn-light dropdown-toggle"
                    id="dropdownServiceActions"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i data-feather="more-vertical" class="text-primary"></i>
                  </a>
                  <div
                    ngbDropdownMenu
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownServiceActions"
                  >
                    <a
                      class="dropdown-item d-flex align-items-center text-primary"
                      [routerLink]="['/go-service/service-details', service.id]"
                    >
                      <i class="bi bi-info-circle mr-2"></i> Info
                    </a>
                                        <a
                      class="dropdown-item d-flex align-items-center "
                      [routerLink]="['/go-service/service-subscribers' , service.id]"
                    >
                      <i class="bi bi-person-fill-down mr-2"></i>Service Subscribers
                    </a>

                    <a
                      *ngIf="service.approvedByAdmin !== true"
                      class="dropdown-item d-flex align-items-center"
                      (click)="serviceStatus(service.id, true)"
                    >
                      <i class="bi bi-check text-success mr-2"></i> Accept
                    </a>
                    <a
                      *ngIf="service.approvedByAdmin !== false"
                      class="dropdown-item d-flex align-items-center"
                      (click)="programContentModal(rejection, service.id)"
                    >
                      <i class="bi bi-x text-danger mr-2"></i> Reject
                    </a>
                    <a
                      class="dropdown-item d-flex align-items-center"
                      (click)="suspendService(service.id)"
                    >
                      <i class="bi bi-trash text-danger mr-2"></i> Suspend
                      Service
                    </a>
                  </div>
                </div>
              </div>
              <img
                class="card-img-top img-fluid"
                [src]="service.banner?.url"
                alt="Card image cap"
                style="object-fit: cover; height: 200px ;"
              />
            </div>

            <!-- <div
              class="card-header d-flex justify-content-between align-items-center mb-1"
            >
              <div class="d-flex align-items-center">
                <div class="avatar mr-50">
                  <img
                    [src]="getAuthorImage(service)"
                    alt="Avatar"
                    width="40"
                    height="40"
                  />
                </div>
                <div class="author-info">
                  <small class="text-muted me-25">by</small>
                  <a 
                  class="text-dark"
                  [routerLink]="['/profile', service?.user?.id]"
                  >
                                      <small class="fw-bold">
                    {{
                      service?.user?.firstName + " " + service?.user?.lastName
                    }}
                  </small>
                  </a>
                </div>
              </div>
            </div> -->

            <div class="card-body d-flex flex-column flex-grow-1">
              <div class="d-flex justify-content-between align-items-center">
                <h4 class="card-title">{{ service.name }}</h4>
                <div class="d-flex flex-column align-items-end">
                  <span
                    *ngIf="service.approvedByAdmin === true"
                    class="custom-badge badge mb-1"
                    [ngClass]="{
                      'badge-light-secondary': service.status === 'draft',
                      'badge-light-primary': service.status === 'published',
                      'badge-light-danger': service.status === 'rejected'
                    }"
                  >
                    {{ service.status | uppercase }}</span
                  >

                  <span
                    class="custom-badge badge mb-1"
                    [ngClass]="{
                      'badge-light-danger': service.approvedByAdmin === false,
                      'badge-light-success': service.approvedByAdmin === true,
                      'badge-light-secondary': service.approvedByAdmin === null
                    }"
                  >
                    {{
                      (service.approvedByAdmin === true
                        ? "Approved"
                        : service.approvedByAdmin === false
                        ? "Rejected"
                        : "Waiting For Action"
                      ) | uppercase
                    }}

                    <ng-container *ngIf="service.approvedByAdmin === false">
                      <button
                        type="button"
                        class="btn btn-sm btn-icon btn-light-primary"
                        [ngbPopover]="milestoneContent"
                        popoverTitle="REJECTION REASON "
                        placement="left"
                        triggers=" click:blur"
                        container="body"
                      >
                        <i
                          data-feather="x-circle"
                          class="font-medium-1 text-danger"
                        ></i>
                      </button>

                      <ng-template #milestoneContent>
                        <div class="card-title">
                          <p class="text-black">
                            {{ service.rejectionReason }}
                          </p>
                        </div>
                      </ng-template>
                    </ng-container>
                  </span>
                </div>
              </div>

              <!-- Content section -->
              <p class="card-text">
                {{ service.description }}
              </p>

              <!-- First badge -->
              <div
                class="d-flex align-items-center justify-content-start truncated-lables"
              >
                <span class="badge bg-goalngo mr-1">
                  {{ service.category.split("_").join(" ") | uppercase }}
                </span>

                <span class="badge bg-goalngo">
                  {{ service.subCategory }}
                </span>
              </div>

              <!-- Footer section pinned to bottom -->
              <div
                class="mt-auto pt-3 d-flex justify-content-between align-items-center border-top"
              >
                <span class="d-flex align-items-center">
                  <i
                    class="bi bi-check-circle bg-outline-goalngo"
                    style="font-size: 1.5rem; margin-right: 0.5rem"
                  ></i>
                  {{ service.completedJobs }} Job Completed
                </span>
                <div class="d-flex flex-column align-items-center">
                  <span
                    class="badge bg-goalngo text-white fs-2 fw-bold rounded-pill"
                  >
                    {{
                      service.paymentConfig?.amount / 100 +
                        " " +
                        service.paymentConfig?.currency
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
              </div>

              <div *ngIf="services.length === 0 && activePill === 'userServices'"
                class="card d-flex justify-content-center align-items-center h-75">
                <div class="text-center py-5">
                  <i class="bi bi-inbox text-muted" style="font-size: 3rem;"></i>
                  <h3 class="font-weight-bold mt-2">No service to Display</h3>
                  <p class="text-muted">There are currently no service available for {{userData.firstName+ " " +
                    userData.lastName}}.</p>
                </div>
              </div>
            </ng-container>


            <ng-container *ngIf="activePill === 'home'">
              <div class="card">

                <div class="card-header">
                  <h4 class="card-title">Player Overview</h4>
                </div>
                <div class="card-body p-1">
                  <div class="d-flex align-items-start mb-1">

                    <div>
                      <p class="mb-0">
                        <i class="bi bi-dot text-primary fs-1"></i>
                        <span>Primary Position:</span>
                        <strong class="text-dark">{{ userData.primaryPosition }}</strong>
                      </p>
                    </div>
                  </div>


                  <div class="d-flex align-items-start">

                    <div>
                      <p class="mb-0">
                        <i class="bi bi-dot text-warning fs-1"></i>
                        <span>Other Positions:</span>
                        <strong class="text-dark">{{ userData.otherPosition }}</strong>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-12" *ngFor="let overview of userData.overview">
                  <div class="d-flex justify-content-center">
                    <div class="card col-10">
                      <div class="card-header d-flex justify-content-between align-items-center">
                        <div>
                          <h2 class="fw-bolder mb-0">{{ overview.value }}</h2>
                          <p class="card-text">{{ overview.title.toUpperCase() }}</p>
                        </div>
                        <div class="avatar bg-light-success p-50 m-0">
                          <div class="avatar-content">
                            <img src="assets/images/icons/{{ overview.key }}.svg" alt="Icon"
                              (error)="handleImageError($event)" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>




              </div>
            </ng-container>
          </div>

          <div *ngIf="userActivities.length === 0 && activePill === 'feed'"
            class="card d-flex justify-content-center align-items-center h-75 w-100">
            <div class="text-center py-5">
              <i class="bi bi-inbox text-muted" style="font-size: 3rem;"></i>
              <h3 class="font-weight-bold mt-2">No Posts to Display</h3>
              <p class="text-muted">There are currently no posts available.</p>
            </div>
          </div>

          <!-- Loop over posts if they exist -->
          <!-- Loop over posts if they exist -->
          <ng-container *ngIf="activePill === 'feed' && userActivities.length > 0">
            <div class="row ml-1">
              <div class="col-6" *ngFor="let userActivityItem of userActivities ">
                <div class="card mb-4">
                  <ng-container>
                    <app-event-post *ngIf="userActivityItem.postType === 'EVENT'"
                      [postItem]="userActivityItem"></app-event-post>

                    <app-shared-basic-post
                      *ngIf="userActivityItem.postType === 'BASIC' && userActivityItem.sharedPost?.postType === 'BASIC'"
                      [postItem]="userActivityItem" [mentionedUsers]="mentionedUsers"></app-shared-basic-post>

                    <app-basic-post *ngIf="userActivityItem.postType === 'BASIC' && !userActivityItem.sharedPost"
                      [postItem]="userActivityItem"></app-basic-post>

                    <app-challenge-post *ngIf="userActivityItem.postType === 'CHALLENGE'"
                      [postItem]="userActivityItem"></app-challenge-post>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>

          <!--/ center profile info section -->
          <!-- right profile info section -->
          <div class="col-lg-3 col-12 order-3" *ngIf="activePill != 'feed'">
            <!-- suggestion -->
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                  <h5 class="mb-2">Network</h5>
                  <a *ngIf="totalUserNetworks > 10" href="javascript:void(0)" class="text-muted text-nowrap">
                    +{{ totalUserNetworks - 10 }} more
                  </a>
                </div>
                <div class="d-flex justify-content-start align-items-center mt-1" *ngFor="let network of userNetworks">
                  <div class="avatar mr-75">
                    <img [src]="network.avatar" alt="avatar" height="40" width="40" class="rounded-circle" />
                  </div>
                  <div class="profile-user-info">
                    <h6 class="mb-0">{{ network.name }}</h6>
                    <small class="text-muted">
                      {{ network.city }}, {{ network.country }}
                    </small>
                  </div>
                  <button hidden type="button" class="btn btn-primary btn-icon btn-sm ml-auto" rippleEffect>
                    <i data-feather="user-plus"></i>
                  </button>
                </div>

                <!-- Show message if no networks exist -->
                <div *ngIf="userNetworks.length === 0" class="text-muted text-center mt-2">
                  No connections found.
                </div>
              </div>
            </div>
            <!--/ suggestion -->

            <!-- PLAYER OVERVIEW -->


          </div>
          <!--/ right profile info section -->
        </div>
      </section>
      <!--/ profile header -->
    </div>
  </div>
</div>